export default "__VITE_ASSET__WSIT_sAH__"